<template>
<div id="chronic_disease" class="flex-c">
    <van-image v-for="(item, index) in imgList" :key="index" :src="item.url" @click="enterDisease(item.name)" class="wrap flex-self-ctr" :class="index === 1? 'bottom' : ''" :width="index === 2 ? '10rem': '9.2rem'" />
</div>
</template>

<script>
export default {
    data() {
        return {
            imgList: [{
                name: '心血管',
                url: require('@/assets/cardiovascular.png')
            }, {
                name: '代谢',
                url: require('@/assets/metabolize.png')
            }, {
                url: require('@/assets/disease.jpg')
            }]
        }
    },
    created() {
    },
    methods: {
        enterDisease(val) {
            if (val) {
                this.$router.push({ path: '/chronic_disease/list', query: {type: val}})
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#chronic_disease{
    padding-top: 30px;
    .wrap{
        width: 690px;
        margin-bottom: 30px;
        &.bottom{
            margin-bottom: 0;
        }
    }
}
</style>
